import { com } from '@eidu/form'
import entityApiUrl from '../baseUrl'
import EntityId = com.eidu.sharedlib.entity.EntityId
import requireAuthContext from '../../authorization/requireAuthContext'

type InviteAuthUserParameters = {
  entityId: EntityId
}

export enum InviteAuthUserResult {
  Success,
  UserUnavailable,
}

const inviteAuthUser = async ({ entityId }: InviteAuthUserParameters) => {
  const authContext = await requireAuthContext()
  const response = await fetch(
    `${entityApiUrl}/organizations/${authContext.organizationId}/entities/${entityId.toString()}/user/invite`,
    {
      headers: {
        Authorization: `Bearer ${authContext.accessToken}`,
        'Content-Type': 'application/json',
      },
      method: 'POST',
    }
  )
  if (response.status === 200) return InviteAuthUserResult.Success
  else if (response.status === 404) return InviteAuthUserResult.UserUnavailable
  else throw Error(`Unexpected response code ${response.status} when inviting user for entity ${entityId.toString()}`)
}

export default inviteAuthUser
